export default __webpack_public_path__ + "static/media/jura.197ad0d1.png";